
import { alpha } from '@mui/material';
import { createTheme, responsiveFontSizes, Theme } from '@mui/material/styles';
import { GRID_LOCALE_TEXT } from './app/common/components/AdminDataGrid/muiGridLocale';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme { }
}

let theme = createTheme();

theme = createTheme({
  palette: {
    primary: {
      main: '#0277BD',
      dark: '#173D65',
      contrastText: alpha('#fff', 0.75),
    },
    action: {
      active: '#5F6368'
    },
    secondary: {
      main: '#FFFFFF',
      light: alpha('#FFFFFF', 0.5),
    }
  },
  typography: {
    fontFamily: 'Roboto, Helvetica Neue, sans-serif',
    subtitle2: {
      fontSize: '1.2em',
      marginTop: '1rem',
      fontWeight: 700
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        }
      }
    },
    MuiSvgIcon: {
      defaultProps: {
        color: 'action',
      }
    },
    MuiFilledInput: {
      defaultProps: {
        margin: 'dense',
        size: 'small'
      }
    },
    MuiFormControl: {
      defaultProps: {
        margin: 'dense',
        size: 'small'
      },
      styleOverrides: {
        root: {
          marginTop: theme.spacing(1.5),
          marginBottom: theme.spacing(1),
        }
      }
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: 'dense'
      }
    },
    MuiIconButton: {
      defaultProps: {
        size: 'small',
      },
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: alpha(theme.palette.background.default, 0.25)
          },
        }
      }
    },
    MuiInputBase: {
      defaultProps: {
        margin: 'dense',
        size: 'small'
      }
    },
    MuiInputLabel: {
      defaultProps: {
        margin: 'dense',
        variant: 'outlined'
      }
    },
    MuiListItem: {
      defaultProps: {
        dense: true
      }
    },
    MuiOutlinedInput: {
      defaultProps: {
        margin: 'dense'
      }
    },
    MuiFab: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiTable: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiTextField: {
      defaultProps: {
        margin: 'dense',
        variant: 'outlined',
      }
    },
    MuiSelect: {
      defaultProps: {
        margin: 'dense',
        variant: 'outlined',
      }
    },
    MuiToolbar: {
      defaultProps: {
        variant: 'dense'
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          flexGrow: 1,
          maxWidth: 'unset',
          textTransform: 'capitalize'

        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '4px 24px'
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          marginRight: theme.spacing(2)
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          flexDirection: 'column'
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            width: theme.spacing(2.667),
            height: theme.spacing(2.667),
            stroke: 'white',
            strokeWidth: '1px',
            opacity: '0.8'
          },
        }
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            stroke: 'white',
            strokeWidth: '1px',
            opacity: '0.8'
          },
        }
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
            width: '10px',
            height: '10px',
          },
        },
      },
    },
  },
}, {
  components: {
    MuiDataGrid: {
      defaultProps: {
        disableColumnMenu: true,
        localeText: GRID_LOCALE_TEXT,
      },
    },
    Tooltip: {

    }
  },
});

const themeGlobal = responsiveFontSizes(theme);
export default themeGlobal;
